var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.78,
    height: 15.956,
    viewBox: "0 0 13.78 15.956",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-content-copy",
    "data-name": "Icon material-content-copy",
    d: "M13.154,1.5h-8.7A1.455,1.455,0,0,0,3,2.951V13.1H4.451V2.951h8.7ZM15.33,4.4H7.352A1.455,1.455,0,0,0,5.9,5.852V16.006a1.455,1.455,0,0,0,1.451,1.451H15.33a1.455,1.455,0,0,0,1.451-1.451V5.852A1.455,1.455,0,0,0,15.33,4.4Zm0,11.6H7.352V5.852H15.33Z",
    transform: "translate(-3 -1.5)",
    fill: "#284261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyGreen);
export default __webpack_public_path__ + "static/media/copyGreen.ccdf6d3fe59c60a2ca2d5f6d2d18c95a.svg";
export { ForwardRef as ReactComponent };